export const siteSettings = {
  name: "Swing Tradex",
  link: "https://swingtradex.live",
  email: "support@swingtradex.live",
  appLink: "https://app.swingtradex.live",
};
